import React from "react";
import { FreeMode, Mousewheel, Navigation } from "swiper/modules";
import { Swiper } from "swiper/react";

const PrimarySlider = ({
  children,
  spacing = "16px",
  slidesPerView = {
    1200: { slidesPerView: 5 },
    900: { slidesPerView: 4 },
    600: { slidesPerView: 2 },
    0: { slidesPerView: 1 },
  },
}) => {
  return (
    <Swiper
      navigation={true}
      modules={[Navigation, FreeMode, Mousewheel]}
      breakpoints={slidesPerView}
      freeMode={true}
      mousewheel={true}
      spaceBetween={spacing}
    >
      {children}
    </Swiper>
  );
};

export default PrimarySlider;
